/**
 * WorkPackageDescriptionEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { WorkPackageDescriptionEntity } from "../WorkPackageDescriptionEntity";
declare global {
    interface EntityTypeMap {
        WorkPackageDescription: WorkPackageDescriptionEntity;
    }
}
export abstract class WorkPackageDescriptionGeneratedEntity extends BaseEntity {
    public abstract workPackageDescriptionId: string;
    public abstract templateId: string | null;
    public abstract text: string | null;
    public abstract workPackage: WorkPackageEntity;
}
